import React from 'react';
import FloorIcon from 'assets/svg/floor.svg';
import UnitIcon from 'assets/svg/building-icons/units.svg';
import { useLocale } from 'locale';
import { ConstructionListWrapper } from './styled';
import { Text } from 'ds/components/typography';

interface ConstructionStoriesAndUnitsProps {
  units: number;
  stories: number;
}

export const ConstructionStoriesAndUnits: React.FunctionComponent<ConstructionStoriesAndUnitsProps> = ({ units, stories }) => {
  const { t } = useLocale();

  return(
    <>
      <ConstructionListWrapper>
        <FloorIcon/>
        <Text>{t('unitPage.constructionStories', { count: stories })}</Text>
      </ConstructionListWrapper>
      <ConstructionListWrapper>
        <UnitIcon/>
        <Text>{t('unitPage.constructionUnits', { count: units })}</Text>
      </ConstructionListWrapper>
    </>
  );
};
